export const isVideo = (url) => {
    const checkArray = [];
    for (let i = 1; i < 11; i++) {
        checkArray.push(`_V${i}`);
    }
    return checkArray.some((check) => url.includes(check));
};
